import React from 'react';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import config from '../../config';
import '../../styles/components/DayList.css';
import getDateForIndex from '../../utils/getDateForIndex';
import defaultFormatDate from '../../utils/defaultFormatDate';
import OnLeave from './OnLeave';
import Shifts from './Shifts';
import format from '../../utils/format';

export default inject('planStore', 'filterStore', 'employeeStore', 'shiftStore', 'dayStore')(
  observer(class GridItem extends React.Component {
    constructor(props) {
      super(props);

      this.openShift = this.openShift.bind(this);
      this.syncDay = this.syncDay.bind(this);
      this.addItem = this.addItem.bind(this);
      this.selectDay = this.selectDay.bind(this);
      this.selectShiftId = this.selectShiftId.bind(this);
      this.addEmployee = this.addEmployee.bind(this);

      const date = getDateForIndex(props.columnIndex, config.startDateOffset);
      this.state = {
        date,
        dateFormatted: defaultFormatDate(date),
      };

      this.props.planStore.fetchPlanning(this.state.dateFormatted);
    }

    /**
     * Synchronize day
     * @param {string} date
     * @return {void}
     */
    syncDay(date) {
      this.props.planStore.refreshPlanningForDay(defaultFormatDate(date));
    }

    /**
     * Add item to day
     * @param {string} date
     * @return {void}
     */
    addItem(date) {
      this.props.planStore.setAddItemDate(date);
      this.props.planStore.toggleModal(true, 'newItemModalIsOpen');
    }

    /**
     * Select a day highlight it
     * @param {string} date
     * @return {void}
     */
    selectDay(date) {
      const formattedDate = defaultFormatDate(date);

      this.props.dayStore.setActiveDay(formattedDate);
      this.props.dayStore.toggleModal();
      this.props.employeeStore.fetchEmployees(formattedDate);
    }

    /**
     * Select shift ID
     * @param id
     */
    selectShiftId(id) {
      const selectedShiftId = (this.props.planStore.selectedShiftId !== id) ? id : null;
      this.props.planStore.setSelectedShiftId(selectedShiftId);
    }

    /**
     * Open shift modal
     *
     * @param  {int} id
     * @return {void}
     */
    openShift(id) {
      // Remove the 'old' shift from the modal
      this.props.shiftStore.closeShift();

      // Start fetching the new shift
      this.props.shiftStore.fetchShift(id);

      // Open the shift modal
      this.props.planStore.toggleModal(true);
    }

    addEmployee(employeeId, shiftId) {
      this.props.planStore.addEmployee(employeeId, shiftId);
    }

    render() {
      const { columnIndex, style, filterStore, planStore } = this.props;
      const { date, dateFormatted } = this.state;
      const itemData = this.props.planStore.days[dateFormatted];

      if (!itemData) {
        return (<div />);
      }

      const selectedDay = planStore.selectedDay;

      const evenOddClass = columnIndex % 2 ? 'odd' : 'even';
      let selectedClass = '';
      let weekNumber = null;

      if (selectedDay) {
        selectedClass = selectedDay === dateFormatted ? 'is-selected' : 'is-not-selected';
      }

      const onLeaveElement = filterStore.showOnLeave ? (
        <OnLeave onLeave={itemData.onLeave} />
      ) : null;

      const shifts = (
        <Shifts
          date={date}
          shifts={itemData.shifts}
          openShift={this.openShift}
          selectedShiftId={planStore.selectedShiftId}
          selectShiftId={this.selectShiftId}
          addEmployee={this.addEmployee}
        />
      );

      if (parseInt(format(date, 'i'), 10) === 1) {
        weekNumber = `Week ${format(date, 'I')}`;
      }

      const addButton = config.writeAccess ? (
        <button type="button" className="daylist__add" onClick={() => this.addItem(date)}>
          <FontAwesomeIcon icon="plus" />
        </button>
      ) : null;

      return (
        <div
          className={`daylist__item ${evenOddClass} ${selectedClass}`}
          style={style}
        >
          <div className="daylist__date">
            <button type="button" className="daylist__day-select" onClick={() => this.selectDay(date)}>
              <div className="daylist__week">{weekNumber}&nbsp;</div>
              {format(date, 'dd D MMMM YYYY')}
            </button>

            {addButton}

            <button type="button" className="daylist__sync" onClick={() => this.syncDay(date)}>
              <FontAwesomeIcon icon="sync" />
            </button>
          </div>

          {shifts}

          {onLeaveElement}
        </div>
      );
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/Grid/GridItem.js